/**
 * Create an icon renderer.
 */
export default function createIcon () {
  /**
   * Create an icon.
   *
   * @param {Icon} params
   * @returns {Icon}
   */
  return function icon ({ node, data } = {}) {
    if (!node) throw new Error('Missing required target node')
    if (!data || !data.name) throw new Error('Missing required icon name')

    const { name, size } = data
    const selector = `* > .zb-icon.zb-icon-${name}`
    const existingIcon = node.querySelector(selector)

    if (existingIcon) return { node: existingIcon, data }

    const svgNs = 'http://www.w3.org/2000/svg'
    const xlinkNs = 'http://www.w3.org/1999/xlink'
    const iconElement = document.createElementNS(svgNs, 'svg')
    const use = document.createElementNS(svgNs, 'use')
    const sizeClassName = size ? `zb-icon-${size}` : ''

    iconElement.setAttribute('class', ['zb-icon', `zb-icon-${name}`, sizeClassName].join(' '))
    iconElement.setAttribute('focusable', 'false') // non-standard IE feature
    use.setAttributeNS(xlinkNs, 'xlink:href', `#zb-icon-${name}`)

    iconElement.appendChild(use)
    node.appendChild(iconElement)

    return { node: iconElement, data }
  }
}

/**
 * @typedef {Object} IconData
 * @prop {string} name The id to use from the icon sprite
 * @prop {'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'=} size The size of the icon
 */

/**
 * @typedef {Object} Icon
 * @prop {Element} node Element to place the icon into.
 * @prop {IconData} data Properties of the icon
 */
